export default __webpack_public_path__ + "static/media/you-are-great.24ef4006.mp3";